import AdminService from '../services/admin.services'
const PREFIX = 'admin/';

const state = {
    detailQuotes: []
}

const getters = {
    getDetailQuotes: (state) => state.detailQuotes
}

const actions = {
    requestDetailQuotes({commit}, data){
        return AdminService.post_entity(data.item, data.entity).then(
            response => {
                commit('SET_DETAILS', response)
                return Promise.resolve(response.status)
            }
        )
    }
}

const mutations = {
    SET_DETAILS(state, rs){
        state.detailQuotes = rs.data
    }
}

export const metrics = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}